export const statusEnum = {
  OPEN: 'EM_ABERTO',
  WAITING_CLOSE: 'AGUARDANDO_FECHAMENTO',
  PAID: 'PAGA',
  WAITING_ADM: 'Aguardando ADM',
};

export default function getColorStatus(status) {
  switch (status) {
    case 'PAID':
      return 'status--paga';
    case 'WAITING_CLOSE':
      return 'status--aguardando';
    default:
      return '';
  }
}

export function getStatusName(status) {
  switch (status) {
    case 'OPEN':
      return 'Em aberto';
    case 'WAITING_CLOSE':
      return 'Aguardando fechamento';
    case 'FUTURE':
      return 'Futura';
    case 'WAITING_ADM':
      return 'Aguardando ADM';
    case 'PAID':
      return 'Paga';
    default:
      return '';
  }
}
